import { SilentCronXError } from "./errors.js";

const JOB_NAME_RE = /^[a-zA-Z0-9][a-zA-Z0-9_.:-]{0,127}$/;

export function validateJobName(name: string): void {
  if (!JOB_NAME_RE.test(name)) {
    throw new SilentCronXError(
      "Job name must start with a letter or number and contain only letters, numbers, underscore, dash, dot, or colon"
    );
  }
}

export function assertPositiveNumber(value: number, label: string): void {
  if (!Number.isFinite(value) || value <= 0) {
    throw new SilentCronXError(`${label} must be a positive number`);
  }
}

export function assertTask(task: unknown, label = "task"): asserts task is (...args: never[]) => unknown {
  if (typeof task !== "function") {
    throw new SilentCronXError(`${label} must be a function`);
  }
}
